import { get, keyBy } from "lodash-es";

import { API_ENDPOINTS } from "shared/constants";
import { IJSONAPIItem } from "shared/types";
import { IDataKeys, IDataState } from "shared/types";

// Helper method to update venue in state
export const getMergedVenueState = (
  state: IDataState,
  venue: { [key: string]: IJSONAPIItem },
  venueId: string
) => {
  // transform venue.stages to redux state
  const venueStages = get(venue, [
    API_ENDPOINTS.VENUE(venueId),
    "attributes",
    "stages",
  ])?.map((stage: any) => ({ ...stage.data }));

  // Override default so stages do not get deep merged
  return {
    [IDataKeys.venue]: {
      ...state.data.venue,
      ...venue,
    },
    [IDataKeys.stage]: {
      ...state.data.stage,
      ...keyBy(venueStages, "id"),
    },
  };
};
